var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideModalPlayList("no-playlist")
        }
      },
      model: {
        value: _vm.show_modal_add_plalist,
        callback: function($$v) {
          _vm.show_modal_add_plalist = $$v
        },
        expression: "show_modal_add_plalist"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideModalPlayList("no-playlist")
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("new_podcast")) +
                    "\n                "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("title"),
                        error: _vm.$v.title.$error
                      },
                      on: { input: _vm.$v.title.$touch },
                      model: {
                        value: _vm.title,
                        callback: function($$v) {
                          _vm.title = $$v
                        },
                        expression: "title"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("q-table", {
                attrs: {
                  data: _vm.playlist,
                  columns: _vm.columns,
                  loading: _vm.loading,
                  "row-key": "name",
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [5, 10, 50, 100],
                  "binary-state-sort": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-td",
                            {
                              key: "id",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(props.row.id) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "title", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(props.row.title) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "origin_playlist", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(props.row.origin_playlist) +
                                  "\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              }),
              _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("cancel")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "tertiary",
                        label: _vm.$t("back"),
                        icon: "far fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.hideModalPlayList("no-playlist")
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("save")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("save"),
                        icon: "far fa-save"
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveData()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }